import { ref, type InjectionKey, type Ref } from 'vue'
import { BookingStep } from '../../shared/types/enums'
import { injectStrict } from './utils/inject'

export interface WidgetRouter {
  currentStep: Ref<BookingStep>
  goTo(step: BookingStep): void
  back(): void
}

export const ROUTER_KEY: InjectionKey<WidgetRouter> = Symbol('fg-widget-router')

export function createRouter(initial: BookingStep = BookingStep.Search): WidgetRouter {
  const currentStep = ref<BookingStep>(initial)
  const history: BookingStep[] = []
  return {
    currentStep,
    goTo(step) {
      history.push(currentStep.value)
      currentStep.value = step
    },
    back() {
      const prev = history.pop()
      if (prev !== undefined) currentStep.value = prev
    },
  }
}

export function useRouter(): WidgetRouter {
  return injectStrict(ROUTER_KEY, 'WidgetRouter')
}
